export const classes = {
  hidden: 'hidden',
  move: 'move-button bg-transparent hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-7 dark:text-mauve-2 text-sm py-1 px-3 rounded-lg flex items-center gap-2',
};
